import StotlesAdminAPI from "lib/StotlesAdminApi";
import {
  ApiError,
  ApiErrorFromJSON,
  Configuration,
  DefaultApi,
  instanceOfApiError,
  ResponseError,
} from "./generated/admin-api";
import { defineInjectable } from "./reactInjector";
import { getCSRFToken } from "./utils";

type AdminAPI = {
  legacyAPI: StotlesAdminAPI;
  api: DefaultApi;
};

const ADMIN_API_INJECTABLE = defineInjectable<AdminAPI>("AdminAPI", () => {
  const apiConfig = new Configuration({
    basePath: "",
    headers: {
      "X-CSRF-Token": getCSRFToken() as string,
    },
  });

  return {
    legacyAPI: new StotlesAdminAPI(),
    api: new DefaultApi(apiConfig),
  };
});

export const useAdminApi = ADMIN_API_INJECTABLE.useInstance;

// TODO: Remove once we migrate all admin code to use OpenAPI-generated API classes
export function useStotlesAdminApi(): StotlesAdminAPI {
  const { legacyAPI: stotlesAdminApi } = useAdminApi();
  return stotlesAdminApi;
}

export const AdminAPIProvider = ADMIN_API_INJECTABLE.Provider;

export async function extractApiError(error: ResponseError): Promise<ApiError> {
  const body = await error.response.json();
  if (!instanceOfApiError(body)) {
    throw error;
  }
  return ApiErrorFromJSON(body);
}
